import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { urtoast } from "../../../../../../Layouts/CustomPopup/eventEmitter";
import { handoverawardContest } from "../../../../../../../redux/contest/action";
import { useDispatch } from "react-redux";
import DisplayFileProper from "../../../../../../Common/FilesRelevent/DisplayFileProper";
import { v4 as uuidv4 } from "uuid";
import { isAllowedFile } from "../../../../../../../assests/extention/fileextention";
import pdficon from "../../../../../../Common/FilesRelevent/pdf.png";


export default function ContestUploadFiles({ pd, worksample, setWork_sample, posts }) {
  const [loading, setLoading] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showValidation, setShowValidation] = useState(false);
  const dispatch = useDispatch();

  const handleUpload = (files) => {
    setShowValidation(false);
    const uploadPromises = files.map((file) => {
      if (file.size > 10 * 1024 * 1024) {
        urtoast(`File size exceeds 10MB limit.`);
        return Promise.reject(new Error("File size exceeds limit."));
      }

      if (!isAllowedFile(file)) {
        urtoast("Unsupported file format. Allowed formats: PDF, DOC, DOCX, PPT, PPTX, ZIP, XLS, XLSX, JPG, PNG, JPEG.", 2);
        return Promise.reject(new Error("Unsupported file type."));
      }

      const uniqueId1 = uuidv4();
      const storageRef = ref(
        getStorage(),
        `/Category/${uniqueId1}_${file.name}`,
      );
      const uploadTask = uploadBytesResumable(storageRef, file);
      return uploadTask
        .then(async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          return { file: url };
        })
        .catch((error) => {
          urtoast(`Error uploading ${file.name}: ${error.message}`);
          throw error;
        });
    });

    Promise.all(uploadPromises)
      .then((urls) => {
        const updatedFiles = [...selectedFiles, ...urls];
        setSelectedFiles(updatedFiles);
        setWork_sample((prevData) => ({
          ...prevData,
          files: updatedFiles,
        }));
      })
      .catch((error) => {
        console.error("Error uploading files: ", error);
      });
  };

  const onDrop = (acceptedFiles) => {
    handleUpload(acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const handleDeleteImage = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
    setWork_sample((prevData) => ({
      ...prevData,
      files: updatedFiles,
    }));
  };

  const handovercontestdocuments = () => {
    if (selectedFiles.length === 0) {
      setShowValidation(true);
    } else {
      setShowValidation(false);
      const data = {
        type: "2",
        id: pd?.id,
        post_id: posts?.id,
        status: "13",
        files: selectedFiles,
      };
      dispatch(handoverawardContest(data, setLoading));
    }
  };

  const handleImageError = (e) => {
    e.target.src = pdficon;
  };

  return (
    <div className="add-portfolio">
      <h6 className="skill-right file-attachment">

      </h6>
      <div className="col-md-3 p-0">
        {selectedFiles.length === 0 ? (
          <div className="image-container">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
              className="cover-img w-100"
              alt="Certificate"
            />
            {/* <button>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                alt=""
              />
            </button> */}
          </div>
        ) : (
          selectedFiles.map((item, index) => (
            <div key={index} className="image-container" >
              {/* {item.file.endsWith(".pdf") ? (
                <div className="uploadimages" style={{ width: 100, height: 100 }} >
                  <DisplayFileProper item={item} />
                </div>
              ) : (
                <img
                  className="uploadimages w-100"
                  style={{ borderRadius: '8px', objectFit: 'cover', height: '150px', width: 100, height: 100 }}
                  src={item.file}
                  alt="Uploaded File"
                  onError={handleImageError}
                />
              )} */}
               <DisplayFileProper item={item} />
              <button
                type="button"
                className="delete-button"
                onClick={() => handleDeleteImage(index)}
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                  alt="Delete"
                />
              </button>
            </div>
          ))
        )}
      </div>
      <div style={{ padding: 20, background: "#fff", color: "black", border: "2px dotted orange" }} {...getRootProps({ className: "dropzone borderstylex" })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here...</p>
        ) : (
          <div>
            <p>
              Drag and drop or <span>Browse files</span>
            </p>
            <p style={{ fontSize: "12px", color: "gray", marginTop: "10px", marginBottom: "0", textAlign: "center" }}>
              Images (JPG, PNG, JPEG up to 10MB)<br />
              Documents (PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, ZIP up to 10MB)
            </p>
          </div>
        )}
      </div>
      {showValidation && (
        <p style={{ color: "red", marginTop: "10px" }}>
          Please upload at least one document.
        </p>
      )}
      <button onClick={handovercontestdocuments} className="buttons background-button mx-auto mt-3" style={{ width: 'max-content' }}>
        Submit files
      </button>
    </div>
  );
}
